// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
input,
table,
button {
  font-family: "Nunito", sans-serif !important;
}

html,
body {
  margin: 0;
  height: 100%;
  background: #F0F4F5;
}

footer {
  background: #f9f9f9;
}

#root {
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAEA;;;;EAIE,4CAAA;AAGF;;AAAA;;EAEE,SAAA;EACA,YAAA;EACA,mBAAA;AAGF;;AADA;EACE,mBAAA;AAIF;;AADA;EACE,eAAA;AAIF","sourcesContent":["@import \"style/Variables.module.scss\";\n\nbody,\ninput,\ntable,\nbutton {\n  font-family: \"Nunito\", sans-serif !important;\n}\n\nhtml,\nbody {\n  margin: 0;\n  height: 100%;\n  background: $theme-background-color;\n}\nfooter {\n  background: #f9f9f9;\n}\n\n#root {\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"themeBgColorExpandButton": `#F0F4F5`
};
export default ___CSS_LOADER_EXPORT___;
